import { useMemo } from 'react';

import type { Insight } from 'types/Insight';

import { TXN_MAP } from 'types/constants';

export const MailchimpPaylinkForumId = 966834;

export const useCustomForumId = (insight: Insight) => {
  const customForumId = useMemo(() => {
    if (insight.offeringId === TXN_MAP.OFFERING_TYPES.MAILCHIMP) {
      return MailchimpPaylinkForumId;
    }
    return undefined;
  }, [insight.offeringId]);

  return { customForumId };
};
